
import { MenuId } from '@/entity/entity'
import { Route } from '@/entity/route'
import { StorageAccess } from '@/scripts/storage-access'
import Vue from 'vue'

export default Vue.extend({
  name: 'MenuList',
  data: function () {
    return {
      menus: StorageAccess.getMenus(),
      searchLink: Route.Search.path,
      searchCari: Route.SearchCari.path,
      searchMainFood: Route.SearchMainFood.path,
      calculationLink: Route.Calculation.path
    }
  },
  methods: {
    getLinkToDetail: function (menuId: MenuId) : string {
      return Route.EditMenu.getPath(menuId)
    },
    deleteMenu: function (index: number) {
      const cf = confirm('料理を削除します。よろしいですか？')
      if (!cf) return
      this.menus.splice(index, 1)
      StorageAccess.setMenus(this.menus)
    }
  }
})
